import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';
import useIntlMessage from '@app/hooks/use-intl-message';
import Button from '@components/buttons/Button';
import './ExpandableInput.scss';

const ExpandableInput = ({
  titleLocKey,
  placeholderLocKey,
  collapseLocKey,
  maxLength = 200,
  value,
  expanded,
  readOnly,
  onValueChange,
  onExpandedChange,
}) => {
  const [inputPlaceholder] = useIntlMessage(placeholderLocKey);
  const textareaRef = useRef(null);

  const handleCollapse = e => {
    onExpandedChange(false);
  };

  const handleExpand = e => {
    if (!e.target.closest('.expandable-input__collapse-button')) {
      onExpandedChange(true);
    }
  };

  useEffect(() => {
    if (expanded && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [expanded]);

  return (
    <div
      id="expandable-input"
      className={classnames('expandable-input', { expanded })}
      onClick={handleExpand}
      onKeyDown={e => e.key === 'Enter' && handleExpand()}
      aria-expanded={expanded}
      role="button"
      tabIndex={expanded ? -1 : 0}
    >
      <div className="expandable-input__label">
        <LocalizedText id={titleLocKey} tagName="span" />
      </div>
      <textarea
        ref={textareaRef}
        className="expandable-input__textarea"
        placeholder={inputPlaceholder}
        value={value || ''}
        maxLength={maxLength}
        onChange={e => onValueChange(e.target.value)}
        disabled={readOnly}
      />
      <Button className="expandable-input__collapse-button" onClick={handleCollapse}>
        <LocalizedText id={collapseLocKey} tagName="span" />
      </Button>
    </div>
  );
};

ExpandableInput.propTypes = {
  onValueChange: PropTypes.func,
  onExpandedChange: PropTypes.func,
  titleLocKey: PropTypes.string,
  placeholderLocKey: PropTypes.string,
  collapseLocKey: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  expanded: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default ExpandableInput;
